export default __webpack_public_path__ + "static/media/02-Foto-grande.55f5d067.jpg";